import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 23px;

  @media (max-width: 720px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ActionsBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  background: ${COLORS['neutral/50']};
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 10px;
  margin-left: auto;

  @media (max-width: 920px) {
    padding: 8px 14px;
    gap: 8px;
  }

  @media (max-width: 720px) {
    margin-left: 0;
  }
`;

export const ActionsBoxPrice = styled.div`
  min-width: 122px;
  display: flex;
  gap: 10px;
`;

export const StyledButton = styled(Button)`
  && {
    border: 1px solid ${COLORS['neutral/200']};
    width: 36px;
    height: 36px;
    padding: 4px;

    &:hover {
      svg {
        transform: scale(1.05);
      }
    }
    svg {
      transition: transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1), fill 0.22s ease, stroke 0.22s ease;
      transform-origin: center center;
    }
  }
`;

export const AddressBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
